<template>
  <div>
    <Head title="Tambah Permohonan Beasiswa" />
    <h1 class="mb-8 text-2xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/scholar-applications">Permohonan Beasiswa</Link>
      <span class="font-medium text-indigo-400">/</span> Tambah Data
    </h1>
    <div class="w-full bg-white rounded-md shadow">
      <form @submit.prevent="store">
        <div class="flex flex-wrap p-8 -mb-8 -mr-6">
          <div class="w-full pb-8 pr-6 lg:w-1/3">
            <label for="scholarship_id" class="form-label">Periode Beasiswa</label>
            <v-select
              v-model="form.scholarship_id" :options="scholarships" :reduce="scholarship => scholarship.id"
              label="periode" placeholder="Pilih Periode Beasiswa"
            />
            <div v-if="form.errors.scholarship_id" class="form-error">{{ form.errors.scholarship_id }}</div>
          </div>
          <text-input
            v-model.number="form.penghasilan_orangtua" type="number" :error="form.errors.penghasilan_orangtua"
            class="w-full pb-8 pr-6 lg:w-1/3" label="Penghasilan Orang Tua"
          />
          <text-input
            v-model.number="form.jumlah_tanggungan_orangtua" type="number"
            :error="form.errors.jumlah_tanggungan_orangtua" class="w-full pb-8 pr-6 lg:w-1/3"
            label="Jumlah Tanggungan Orang Tua"
          />
          <select-input
            v-model="form.semester" :error="form.errors.semester" class="w-full pb-8 pr-6 lg:w-1/3"
            label="Semester"
          >
            <option value="1">Semester 1</option>
            <option value="2">Semester 2</option>
            <option value="3">Semester 3</option>
            <option value="4">Semester 4</option>
            <option value="5">Semester 5</option>
            <option value="6">Semester 6</option>
            <option value="7">Semester 7</option>
            <option value="8">Semester 8</option>
          </select-input>
          <text-input
            v-model.number="form.nilai_ukt" type="number" :error="form.errors.nilai_ukt"
            class="w-full pb-8 pr-6 lg:w-1/3" label="Nilai UKT (Uang Kuliah Tunggal)"
          />
          <div class="w-full pb-8 pr-6 lg:w-1/3">
            <label for="is_prasejahtera" class="form-label">Kondisi Ekonomi</label>
            <input id="is_prasejahtera" v-model="form.is_prasejahtera" type="checkbox" class="mr-2" />
            <label for="is_prasejahtera" class="items-center cursor-pointer">
              Tidak Mampu (Pra-Sejahtera)
            </label>
          </div>

          <div class="w-full pb-8 pr-6 lg:w-1/3">
            <label for="scholarship_id" class="form-label">Prestasi Akademik/ Non Akademik</label>
            <div class="w-full pb-8 pr-6 ">
              <div class="w-full pb-4 pr-6 ">
                <input id="is_berprestasi_internasional" v-model="form.is_berprestasi_internasional" type="checkbox" class="mr-2" />
                <label for="is_berprestasi_internasional" class="items-center cursor-pointer">
                  Internasional
                </label>
              </div>
              <div class="w-full pb-4 pr-6 ">
                <input id="is_berprestasi_nasional" v-model="form.is_berprestasi_nasional" type="checkbox" class="mr-2" />
                <label for="is_berprestasi_nasional" class="items-center cursor-pointer">
                  Nasional
                </label>
              </div>
              <div class="w-full pb-4 pr-6 ">
                <input id="is_berprestasi_lokal" v-model="form.is_berprestasi_lokal" type="checkbox" class="mr-2" />
                <label for="is_berprestasi_lokal" class="items-center cursor-pointer">
                  Provinsi
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="flex items-center justify-end px-8 py-4 border-t border-gray-100 bg-gray-50">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            <font-awesome-icon class="mr-2" icon="fas fa-key" />Simpan
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '../../Shared/SelectInput.vue'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    SelectInput,
  },
  layout: Layout,
  remember: 'form',
  props: {
    mou: Boolean,
    scholarships: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        scholarship_id: null,
        penghasilan_orangtua: 0,
        nilai_ukt: 0,
        jumlah_tanggungan_orangtua: 2,
        semester: 1,
        is_berprestasi: false,
        is_prasejahtera : false,
        is_berprestasi_internasional : false,
        is_berprestasi_nasional : false,
        is_berprestasi_lokal : false,
      }),
    }
  },

  methods: {
    store() {
      this.form.post(this.route('scholar-applications.store'))
    },
  },
}
</script>
